var AdActions = /* @__PURE__ */(AdActions2 => {
  AdActions2["AD_START"] = "ad-start";
  AdActions2["AD_STOP"] = "ad-stop";
  AdActions2["AD_BLOCKER_DETECTED"] = "ad-blocker-detected";
  AdActions2["AD_ERRORED"] = "ad-errored";
  return AdActions2;
})(AdActions || {});
var TealiumEventNames = /* @__PURE__ */(TealiumEventNames2 => {
  TealiumEventNames2["PLAYER_START"] = "player_start";
  TealiumEventNames2["PLAYER_PLAY"] = "player_play";
  TealiumEventNames2["PLAYER_SKIP"] = "player_skip";
  TealiumEventNames2["PLAYER_MENU_PLAY"] = "player_menu_play";
  TealiumEventNames2["PLAYER_RESUME"] = "player_resume";
  TealiumEventNames2["PLAYER_STOP"] = "player_stop";
  TealiumEventNames2["PLAYER_SWITCH"] = "player_switch";
  TealiumEventNames2["PLAYER_PAUSE"] = "player_pause";
  TealiumEventNames2["PLAYER_VOLUME"] = "player_volume";
  TealiumEventNames2["PLAYER_COMPLETE"] = "player_complete";
  TealiumEventNames2["PLAYER_HEARTBEAT"] = "player_heartbeat";
  TealiumEventNames2["PLAYER_ERROR"] = "player_error";
  TealiumEventNames2["PLAYER_RECONNECT"] = "player_reconnect";
  TealiumEventNames2["PLAYER_LOAD_MEDIA"] = "player_load_media";
  TealiumEventNames2["PLAYER_CLICK"] = "player_click";
  TealiumEventNames2["OUTBOUND_CLICK"] = "outbound_click";
  return TealiumEventNames2;
})(TealiumEventNames || {});
var TealiumEventCategory = /* @__PURE__ */(TealiumEventCategory2 => {
  TealiumEventCategory2["PLAYER"] = "player";
  return TealiumEventCategory2;
})(TealiumEventCategory || {});
var HeartbeatEvents = /* @__PURE__ */(HeartbeatEvents2 => {
  HeartbeatEvents2["START_HEARTBEAT"] = "START_HEARTBEAT";
  HeartbeatEvents2["STOP_HEARTBEAT"] = "STOP_HEARTBEAT";
  HeartbeatEvents2["RESET_HEARTBEAT"] = "RESET_HEARTBEAT";
  HeartbeatEvents2["UPDATE_TIME"] = "UPDATE_TIME";
  return HeartbeatEvents2;
})(HeartbeatEvents || {});
var HeartbeatIntervals = /* @__PURE__ */(HeartbeatIntervals2 => {
  HeartbeatIntervals2[HeartbeatIntervals2["ONE_MINUTE"] = 6e4] = "ONE_MINUTE";
  HeartbeatIntervals2[HeartbeatIntervals2["SEVEN_MINUTES"] = 42e4] = "SEVEN_MINUTES";
  HeartbeatIntervals2[HeartbeatIntervals2["FIFTEEN_MINUTES"] = 9e5] = "FIFTEEN_MINUTES";
  HeartbeatIntervals2[HeartbeatIntervals2["FORTYFIVE_MINUTES"] = 27e5] = "FORTYFIVE_MINUTES";
  return HeartbeatIntervals2;
})(HeartbeatIntervals || {});
var HeartbeatLabels = /* @__PURE__ */(HeartbeatLabels2 => {
  HeartbeatLabels2[HeartbeatLabels2["LABEL_1"] = 1] = "LABEL_1";
  HeartbeatLabels2[HeartbeatLabels2["LABEL_8"] = 8] = "LABEL_8";
  HeartbeatLabels2[HeartbeatLabels2["LABEL_15"] = 15] = "LABEL_15";
  return HeartbeatLabels2;
})(HeartbeatLabels || {});
var VolumeEventLabel = /* @__PURE__ */(VolumeEventLabel2 => {
  VolumeEventLabel2["MUTE"] = "mute";
  VolumeEventLabel2["UNMUTE"] = "umute";
  VolumeEventLabel2["UP"] = "up";
  VolumeEventLabel2["DOWN"] = "down";
  return VolumeEventLabel2;
})(VolumeEventLabel || {});
var EventPageSection = /* @__PURE__ */(EventPageSection2 => {
  EventPageSection2["ABOVE_THE_FOLD"] = "above-the-fold";
  EventPageSection2["BELOW_THE_FOLD"] = "below-the-fold";
  return EventPageSection2;
})(EventPageSection || {});
var MediaBitrate = /* @__PURE__ */(MediaBitrate2 => {
  MediaBitrate2["64KBPS"] = "64kbps";
  MediaBitrate2["128KBPS"] = "128kbps";
  MediaBitrate2["256KBPS"] = "256kbps";
  MediaBitrate2["320KBPS"] = "320kbps";
  return MediaBitrate2;
})(MediaBitrate || {});
var MediaQuality = /* @__PURE__ */(MediaQuality2 => {
  MediaQuality2["240P"] = "240p";
  MediaQuality2["360P"] = "360p";
  MediaQuality2["480P"] = "480p";
  MediaQuality2["720P"] = "720p";
  MediaQuality2["1080P"] = "1080p";
  return MediaQuality2;
})(MediaQuality || {});
var MediaType = /* @__PURE__ */(MediaType2 => {
  MediaType2["VIDEO"] = "video";
  MediaType2["AUDIO"] = "audio";
  return MediaType2;
})(MediaType || {});
var MediaAudioType = /* @__PURE__ */(MediaAudioType2 => {
  MediaAudioType2["PODCAST"] = "podcast";
  MediaAudioType2["RADIO_LIVE"] = "radio-live";
  MediaAudioType2["ONDEMAND_RADIO"] = "ondemand-radio";
  MediaAudioType2["LUISTERBOEK"] = "luisterboek";
  return MediaAudioType2;
})(MediaAudioType || {});
var MediaVideoType = /* @__PURE__ */(MediaVideoType2 => {
  MediaVideoType2["EPISODE"] = "episode";
  MediaVideoType2["CLIP"] = "clip";
  MediaVideoType2["LIVE"] = "live";
  MediaVideoType2["MOVIE"] = "movie";
  MediaVideoType2["SERIES"] = "series";
  return MediaVideoType2;
})(MediaVideoType || {});
var PageCategory = /* @__PURE__ */(PageCategory2 => {
  PageCategory2["HOME"] = "home";
  PageCategory2["INDEX"] = "index";
  PageCategory2["DETAIL"] = "detail";
  PageCategory2["CART"] = "cart";
  return PageCategory2;
})(PageCategory || {});
var PlayerCasting = /* @__PURE__ */(PlayerCasting2 => {
  PlayerCasting2["AIRPLAY"] = "airplay";
  PlayerCasting2["CHROMECAST"] = "chromecast";
  PlayerCasting2["HEOS"] = "heos";
  PlayerCasting2["CARPLAY"] = "carplay";
  return PlayerCasting2;
})(PlayerCasting || {});
var PlayerStatus = /* @__PURE__ */(PlayerStatus2 => {
  PlayerStatus2["DURATION"] = "duration";
  PlayerStatus2["END"] = "end";
  PlayerStatus2["MUTE"] = "mute";
  PlayerStatus2["PAUSE"] = "pause";
  PlayerStatus2["PLAY"] = "play";
  PlayerStatus2["RESUME"] = "resume";
  PlayerStatus2["START"] = "start";
  PlayerStatus2["STOP"] = "stop";
  PlayerStatus2["UNMUTE"] = "unmute";
  PlayerStatus2["ERROR"] = "error";
  PlayerStatus2["IDLE"] = "idle";
  PlayerStatus2["DISCONNECT"] = "disconnect";
  return PlayerStatus2;
})(PlayerStatus || {});
var PlayerForm = /* @__PURE__ */(PlayerForm2 => {
  PlayerForm2["NORMAL_PLAYER"] = "normal player";
  PlayerForm2["FLOATING_PLAYER"] = "floating player";
  return PlayerForm2;
})(PlayerForm || {});
const tealiumEventBaseGroupPrefix = "event_";
const tealiumEventParentGroupPrefix = "parent_";
const tealiumEventMediaGroupPrefix = "media_";
const tealiumEventPageGroupPrefix = "page_";
const tealiumEventPlayerGroupPrefix = "player_";
const tealiumEventExperimentGroupPrefix = "experiment_";
var PlayerEvents = /* @__PURE__ */(PlayerEvents2 => {
  PlayerEvents2["STREAM_METADATA_LOADED"] = "loadedmetadata";
  PlayerEvents2["STREAM_START"] = "stream-start";
  PlayerEvents2["STREAM_STOP"] = "stream-stop";
  PlayerEvents2["STREAM_PAUSE"] = "pause";
  PlayerEvents2["STREAM_SWITCH"] = "stream-switch";
  PlayerEvents2["STREAM_ENDED"] = "stream-ended";
  PlayerEvents2["PLAYER_DISCONNECTED"] = "disconnected";
  PlayerEvents2["PLAYER_PLAYING"] = "playing";
  PlayerEvents2["PLAYER_EMPTIED"] = "emptied";
  PlayerEvents2["STREAM_RESUMED"] = "stream-resumed";
  PlayerEvents2["STREAM_ERROR"] = "stream-error";
  PlayerEvents2["STREAM_STATUS"] = "stream-status";
  PlayerEvents2["STREAM_STALLED"] = "stream-stalled";
  PlayerEvents2["TRACK_CUE_POINT"] = "track-cue-point";
  PlayerEvents2["HEARTBEAT"] = "heartbeat";
  PlayerEvents2["ONLINE"] = "online";
  PlayerEvents2["OFFLINE"] = "offline";
  PlayerEvents2["PLAYER_RECONNECT"] = "player_reconnect";
  PlayerEvents2["PLAYER_RECONNECTING"] = "player_reconnecting";
  PlayerEvents2["VOLUME_CHANGED"] = "volumechange";
  PlayerEvents2["STREAM_MUTED"] = "stream-muted";
  PlayerEvents2["STREAM_UNMUTED"] = "stream-unmuted";
  PlayerEvents2["STREAM_MUTE_STOP"] = "stream-mute-stop";
  PlayerEvents2["STREAM_UNMUTE_START"] = "stream-unmute-start";
  PlayerEvents2["TIME_UPDATE"] = "timeupdate";
  PlayerEvents2["DURATION_CHANGE"] = "durationchange";
  PlayerEvents2["STREAM_CONFIG_ERROR"] = "stream-config-error";
  PlayerEvents2["STREAM_FAIL"] = "stream-fail";
  PlayerEvents2["STREAM_CONFIG_LOAD_ERROR"] = "stream-config-load-error";
  return PlayerEvents2;
})(PlayerEvents || {});
var StreamType = /* @__PURE__ */(StreamType2 => {
  StreamType2["STATION"] = "station";
  StreamType2["PODCAST"] = "podcast";
  StreamType2["CLIP"] = "clip";
  return StreamType2;
})(StreamType || {});
var PlaybackMode = /* @__PURE__ */(PlaybackMode2 => {
  PlaybackMode2["LIVE_AUDIO"] = "LIVE_AUDIO";
  PlaybackMode2["ON_DEMAND_CLIP"] = "ON_DEMAND_CLIP";
  return PlaybackMode2;
})(PlaybackMode || {});
var PlayerType = /* @__PURE__ */(PlayerType2 => {
  PlayerType2["AUDIO"] = "audio";
  PlayerType2["TRITON"] = "triton";
  return PlayerType2;
})(PlayerType || {});
var __defProp = Object.defineProperty;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, {
  enumerable: true,
  configurable: true,
  writable: true,
  value
}) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {})) if (__hasOwnProp.call(b, prop)) __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols) for (var prop of __getOwnPropSymbols(b)) {
    if (__propIsEnum.call(b, prop)) __defNormalProp(a, prop, b[prop]);
  }
  return a;
};
class PlayerStateManager {
  constructor() {
    let initialState = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    this.state = {
      volumeLevel: 1
    };
    this.state = __spreadValues(__spreadValues({}, this.state), initialState);
  }
  setState(state) {
    this.state = __spreadValues(__spreadValues({}, this.state), state);
  }
  getState() {
    return this.state;
  }
}
const playerStateManager = new PlayerStateManager();
const init = () => {
  return "core-audio-player-shared -> initial test";
};
export { AdActions, EventPageSection, HeartbeatEvents, HeartbeatIntervals, HeartbeatLabels, MediaAudioType, MediaBitrate, MediaQuality, MediaType, MediaVideoType, PageCategory, PlaybackMode, PlayerCasting, PlayerEvents, PlayerForm, PlayerStateManager, PlayerStatus, PlayerType, StreamType, TealiumEventCategory, TealiumEventNames, VolumeEventLabel, init, playerStateManager, tealiumEventBaseGroupPrefix, tealiumEventExperimentGroupPrefix, tealiumEventMediaGroupPrefix, tealiumEventPageGroupPrefix, tealiumEventParentGroupPrefix, tealiumEventPlayerGroupPrefix };